export default __webpack_public_path__ + "static/media/Mindly.e16475ef.png";